import React from "react";
import cx from "classnames";

const BottomNav = ({ change_slide, active_slide, handle, deck_size }) => {
  return (
    <div className="bottom-nav">
      <div>
        <button
          onClick={() => change_slide(-1)}
          disabled={active_slide <= 1}
          className={cx("btn-next", {
            disabled: active_slide <= 1,
          })}
          className="btn"
        >
          <i className="fas fa-caret-left"></i>
        </button>
        {active_slide} of {deck_size}
        <button
          onClick={() => change_slide(1)}
          disabled={active_slide >= deck_size}
          className={cx("btn-next", {
            disabled: active_slide >= deck_size,
          })}
          className="btn"
        >
          <i className="fas fa-caret-right"></i>
        </button>
      </div>
      <button onClick={handle.enter} className="btn fullscreen-btn">
        <i className="fas fa-expand-arrows-alt"></i>
      </button>
    </div>
  );
};

export default BottomNav;
